import type { Checkout, Product, Products, Upsells, Variant } from '~/types'
import { AukError, makeActionCreator, makeMetaActionCreator } from '~/utils'

export default {
	loadProducts: makeActionCreator()('PRODUCTS_LOAD'),
	productsLoaded: makeActionCreator<Products>()('PRODUCTS_LOAD_SUCCESS'),
	productsFailed: makeMetaActionCreator<AukError>()('PRODUCTS_LOAD_ERROR'),

	loadUpsells: makeActionCreator<Product, Variant>()('UPSELL_LOAD'),
	upsellsLoaded: makeActionCreator<Upsells, ProductID>()('UPSELL_LOAD_SUCCESS'),
	upsellsCartLoaded: makeActionCreator<Checkout, ProductID>()('UPSELL_CART_LOAD_SUCCESS')
}
